/**
 * Vue Router - SPA Routing Configuration
 * Using createWebHistory for clean URLs
 */
import { createRouter, createWebHistory } from 'vue-router';
import { authGuard } from './guards/authGuard';

// Route definitions
import homeRoutes from './routes/home';
import accountRoutes from './routes/account';
import manageRoutes from './routes/manage';
import consentRoutes from './routes/consent';
import grantsRoutes from './routes/grants';
import csRoutes from './routes/cs';

const routes = [
    ...homeRoutes,
    ...accountRoutes,
    ...manageRoutes,
    ...consentRoutes,
    ...grantsRoutes,
    ...csRoutes,

    // Error pages
    // IdentityServer 가 오류를 낼 때 보내는 경로는 /home/error?errorId=... 이므로 alias 로 함께 받는다.
    // 이게 없으면 라우트 매칭이 안 돼 아무것도 렌더되지 않고 빈 화면이 된다 (2026-09-28 사고).
    {
        path: '/error',
        alias: '/home/error',
        name: 'error',
        component: () => import('../pages/shared/ErrorPage.vue'),
        meta: { layout: 'blank', requiresAuth: false },
        props: (route) => ({
            error: route.query.error,
            errorDescription: route.query.errorDescription,
        }),
    },

    // 404 - Not Found
    {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        component: () => import('../pages/shared/NotFoundPage.vue'),
        meta: { layout: 'blank', requiresAuth: false },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return { top: 0 };
    },
});

// Global navigation guard
router.beforeEach(authGuard);

export default router;
